import { useLogoutFunction } from '@propelauth/react';
import { Container, Text } from '@mantine/core';
import { useEffect } from 'react';

const LogoutPage = () => {
  const logout = useLogoutFunction();
  useEffect(() => {
    logout(true);
  }, [logout]);
  return (
    <Container>
      <Text>Logging out...</Text>
    </Container>
  );
};

export default LogoutPage;
